<template>
  <div v-if="!showCreateSituationForm" class="col-span-12 flex flex-col gap-4">
    <div class="flex items-end gap-4 w-full">
      <rpm-input
          class="flex-grow"
          label="Situação"
          placeholder="Situação"
          type="select"
          required
          :options="sourceSituations"
          optionValue="id"
          optionLabel="name"
          v-model="form.source_situation_id"
      />

      <rpm-button
          class="w-fit"
          label="Criar Nova Situação"
          color="primary"
          @click="showCreateSituationForm = true"
      />
    </div>

    <div class="grid grid-cols-12 gap-4">
      <rpm-input
          class="col-span-4"
          label="Próximo Procedimento"
          placeholder="Próximo Procedimento"
          type="select"
          optional
          optionValue="id"
          optionLabel="name"
          :options="availableSourceProcedures"
          v-model="form.next_source_procedure_id"
      ></rpm-input>

      <rpm-input
          class="col-span-4"
          label="Próxima Organização"
          placeholder="Próxima Organização"
          type="multiselect"
          optional
          :options="availableNextOrganizations"
          optionValue="organization_id"
          optionLabel="organization_name"
          v-model="form.next_organizations"
      ></rpm-input>

      <rpm-input
          class="col-span-4"
          label="Status"
          placeholder="Selecione um Status"
          type="select"
          :options="statusOptions"
          optionValue="id"
          optionLabel="label"
          v-model="form.service_status_id"
          required
      ></rpm-input>

      <rpm-input
          type="switch"
          label="Requer Observação"
          class="col-span-6 items-center"
          v-model="form.observation_required"
      ></rpm-input>

      <rpm-input
          type="switch"
          label="Habilitado"
          class="col-span-6 items-center"
          v-model="form.enabled"
      ></rpm-input>
    </div>

    <div class="flex justify-center gap-6 col-span-12 mt-4">
      <rpm-button
          color="gray"
          label="Cancelar"
          @click="close"
      ></rpm-button>

      <rpm-button
          label="Confirmar"
          :loading="loading"
          @click="saveSourceProcedureSituation"
      ></rpm-button>
    </div>
  </div>

  <div v-else class="col-span-12 grid grid-cols-12 gap-4">
    <h2 class="col-span-12 text-lg font-semibold">Criar nova situação</h2>

    <rpm-input
        class="col-span-12"
        label="Descrição da Situação"
        placeholder="Digite a descrição"
        v-model="newSituationForm.description"
        required
    />

    <div class="col-span-12 flex justify-center gap-6 mt-2">
      <rpm-button
          label="Cancelar"
          color="gray"
          @click="cancelNewSituation"
      />
      <rpm-button
          :loading="loading"
          label="Salvar"
          @click="saveNewSituation"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import sourceProcedureSituationStore from '#repositories/sourceProcedureSituationRepository'
import serviceStatusRepository from '#repositories/serviceStatusRepository';

export default {
  name: "AddSourceSituation",
  props: {
    sourceSituations: Array,
    availableSourceProcedures: Array,
    sourceProcedure: Object
  },
  setup(props, { emit }) {
    const form = ref({
      source_situation_id: null,
      next_source_procedure_id: null,
      next_organizations: [],
      service_status_id: null,
      observation_required: false,
      enabled: true
    })

    const loading = ref(false)
    const availableNextOrganizations = ref([])
    const showCreateSituationForm = ref(false)
    const newSituationForm = ref({ description: '' })
    const statusOptions = ref([])

    async function fetchStatuses() {
      try {
        const response = await serviceStatusRepository.getAllStatuses();
        statusOptions.value = response.data;
      } catch (error) {
        console.error('Erro ao buscar status:', error);
      }
    }

    onMounted(() => {
      fetchStatuses();
    });

    function close() {
      emit('close', false)
    }

    function cancelNewSituation() {
      showCreateSituationForm.value = false
      newSituationForm.value.description = ''
    }

    async function saveNewSituation() {
      loading.value = true
      try {
        const payload = {
          description: newSituationForm.value.description,
          enabled: true
        }


        const response = await sourceProcedureSituationStore.createNewSituation(payload)

        const currentSourceSituation = _.last(response.data)

        const novaSituacao = {
          id: currentSourceSituation.id,
          name: currentSourceSituation.label || currentSourceSituation.description,
          enabled: currentSourceSituation.enabled,
          source_situation_id: currentSourceSituation.id
        }

        props.sourceSituations.push(novaSituacao)

        form.value.source_situation_id = novaSituacao.source_situation_id
        showCreateSituationForm.value = false
      } catch (e) {
        console.error('Erro ao criar situação:', e)
      } finally {
        loading.value = false
      }
    }

    function saveSourceProcedureSituation() {
      loading.value = true

      const payload = {
        source_procedure_id: props.sourceProcedure.id,
        source_situation_id: form.value.source_situation_id,
        next_source_procedure_id: form.value.next_source_procedure_id,
        next_organizations: form.value.next_organizations,
        observation_required: form.value.observation_required,
        enabled: form.value.enabled,
        is_default: true,
        service_status_id: form.value.service_status_id
      }


      sourceProcedureSituationStore.storeSourceProcedureSituation(payload)
          .then(() => {
            emit('situationAdded', true)
            emit('close')
          })
          .catch((e) => {
            console.error('Erro ao salvar situação do procedimento:', e)
          })
          .finally(() => {
            loading.value = false
          })
    }

    watch(
        () => form.value.next_source_procedure_id,
        (val) => {
          if (val) {
            sourceProcedureSituationStore
                .fetchNextSourceProcedureOrganizations(val)
                .then((response) => {
                  availableNextOrganizations.value = response.data
                })
          }
        }
    )

    return {
      form,
      loading,
      availableNextOrganizations,
      close,
      showCreateSituationForm,
      newSituationForm,
      cancelNewSituation,
      saveNewSituation,
      saveSourceProcedureSituation,
      statusOptions
    }
  }
}
</script>
